/**
 * Copyright © 2018-present Emu Analytics
 */

import { IContactPoint, IContactPointSendRequest } from './api-interfaces';
import { BaseEndpoints } from './base.endpoints';
import { Client } from './client';

export class ContactPointEndpoints extends BaseEndpoints<IContactPoint> {
  constructor(client: Client) {
    super(client, 'contactpoints');
  }

  /**
   * Send a notification to a contact point.
   */
  send(contactPointId: string, params: IContactPointSendRequest = {}): Promise<void> {
    return this.client._post(`${this.resourceEndpoint}/${contactPointId}/send`, params);
  }

  /**
   * Get a list of available contact point drivers. Supported types include 'email', 'slack', 'teams', 'sns'.
   *
   * Drivers have different required parameters - refer to documentation for details.
   */
  drivers(): Promise<string[]> {
    return this.client._get(`${this.resourceEndpoint}/drivers`);
  }
}
